module.exports = __webpack_public_path__ + "img/security-camera.9aca9f74.svg";